import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { NewRequestDialog } from "@/components/portal/new-request-dialog";
import { RequestsList } from "@/components/portal/requests-list";
import { portalRequestsQuery } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/requests")({
  loader: ({ context }) => context.queryClient.ensureQueryData(portalRequestsQuery),
  component: PortalRequestsPage,
});

function PortalRequestsPage() {
  const { data } = useQuery(portalRequestsQuery);
  // Leave lives under its own section now — keep this list to general asks only.
  const requests = (data ?? []).filter((r) => r.type !== "leave" && r.type !== "study_leave");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-1">
          <h1 className="font-heading font-semibold text-2xl tracking-tight">Requests</h1>
          <p className="text-muted-foreground text-sm">
            Request a document or profile correction from HR. For time off, use the Leave section.
          </p>
        </div>
        <NewRequestDialog />
      </div>
      <RequestsList requests={requests} />
    </div>
  );
}
